import BasicModal from './BasicModal';

export const OFFLINE_MODE_INFO_TITLE = 'Offline Mode';
export const OFFLINE_MODE_INFO_BODY =
  "You're connected to a separate backup environment. Messages sent here do not sync with your " +
  "main organization, and your main organization's message history may not be available.";
export const OFFLINE_MODE_KEEP_TAB_OPEN = 'Keep this tab open to receive messages.';
export const OFFLINE_MODE_INFO_DISMISS = 'Got it';

type OfflineModeInfoModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export default function OfflineModeInfoModal({ isOpen, onClose }: OfflineModeInfoModalProps) {
  return (
    <BasicModal
      ariaLabelBody={'Offline mode information'}
      ariaLabelCancelButton={'Cancel'}
      ariaLabelCloseButton={'Close offline mode information'}
      ariaLabelHeader={'Offline Mode'}
      ariaLabelSubmitButton={'Dismiss offline mode information'}
      hasCloseButton
      headerText={OFFLINE_MODE_INFO_TITLE}
      hideCancel
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onClose}
      submitText={OFFLINE_MODE_INFO_DISMISS}
    >
      <p>{OFFLINE_MODE_INFO_BODY}</p>
      <p>{OFFLINE_MODE_KEEP_TAB_OPEN}</p>
    </BasicModal>
  );
}
